import * as React from 'react';
import { CommentsDialog } from "../../misc/components/CommentsSelector";
import { ToggleSessionFixedCommentsVisibilityAction, ToggleSessionFixedCommentCheckedAction, ToggleTestFixedCommentCheckedAction, ToggleTestFixedCommentsVisibilityAction, TestFixedCommentsState, SessionFixedCommentState } from '../../PulmonaryFunctionTests/Shared/UseFixedComments';

export interface CommentModalsProps {
    editable: boolean;
    sessionFixedComments: SessionFixedCommentState;
    testFixedComments: TestFixedCommentsState[];
    setIsPageValidated: (isValidated: boolean) => void;
    isPageValid: boolean;
    dispatch: React.Dispatch<any>;
}

export const CommentModals = ({ editable, sessionFixedComments, testFixedComments, isPageValid, dispatch }: CommentModalsProps) => {
    const handleSessionCommentsClose = () => {
        dispatch(ToggleSessionFixedCommentsVisibilityAction.create());
    }

    const renderTestModals = () => {
        return (
            testFixedComments.map((tfc) => {
                return (
                    <CommentsDialog
                        key={`CommentsDialog${tfc.id}`}
                        editable={editable}
                        show={tfc.isVisible}
                        header={`Over-reading Fixed Comments - Test ${tfc.testNumber}`}
                        items={tfc.comments}
                        onChange={(id, checked) => dispatch(ToggleTestFixedCommentCheckedAction.create(tfc.id, id, checked))}
                        onClose={() => dispatch(ToggleTestFixedCommentsVisibilityAction.create(tfc.id))}
                    />
                );
            })
        );
    }

    return (
        <>
            {renderTestModals()}
            <CommentsDialog
                show={sessionFixedComments.isVisible}
                header="Over-reading Fixed Comments - Session"
                editable={editable}
                items={sessionFixedComments.comments}
                errorMessage={!isPageValid ? "A session comment is required" : null}
                onChange={(id, checked) => dispatch(ToggleSessionFixedCommentCheckedAction.create(id, checked))}
                onClose={handleSessionCommentsClose}
            />
        </>
    );
}
